import { observer } from "mobx-react";
import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Button, Form, Grid, Header, Icon, Table, Select, Input, GridColumn } from "semantic-ui-react";
import { AlertMessage, DateInput, Text } from "../../../components/common";
import { CurrencyInput } from "../../../components/common/input";
import { NoPermissionMessage } from "../../../components/permission";
import { currency } from "../../../utils/format-helper";
import { hasPermission } from "../../../utils/render-by-permission";
import { IDebtCollectionSueModel } from "../DebtCollectionModel";

interface IDebtCollectionSueCalculator3 extends WithTranslation {
  debtSue: IDebtCollectionSueModel;
}

@observer
class DebtCollectionSueCalculator3 extends React.Component<
  IDebtCollectionSueCalculator3
> {
  state = {
    listData: [],
    total: {
      interestStart: "",
      interestEnd: "",
      dayCal: 0,
      paidEach: 0,
      principle: 0,
      interest: 0,
      principleRemain: 0
    },
    interestStartDate: "",
    paidStartDate: "",
    principleVal: 0,
    interestRate: 0,
    paidEach: 0,
    interestVal: 0,
    totalPaid: 0,
    lawyerFee: 0,
    fee: 0,
    otherExpense: 0,
  }

  componentDidMount(): void {
    const { debtSue } = this.props;
    this.setState({ interestStartDate: debtSue.judgementInterestStartDate });
    this.setState({ principleVal: debtSue.judgementBalance });
    this.setState({ interestRate: debtSue.judgementInterestRate });
    this.setState({ lawyerFee: debtSue.lawyerFee });
    this.setState({ fee: debtSue.fee });
    this.setState({ otherExpense: debtSue.otherExpense });


  }


  public render() {
    const { t, debtSue } = this.props;
    return (
      <Form>
        <Header
          size="medium"
          content={
            t(
              "การคำนวณดอกเบี้ยกรณีทำสัญญาประนีประนอมความ (ชำระกึ่งหนึ่ง)"
            )
          }
          subheader={
            t(
              ""
            )
          } />
        <Form.Group widths="equal">
          <Form.Field
            label={t("วันที่เริ่มคิดดอกเบี้ย")}
            control={DateInput}
            value={this.state.interestStartDate}
            fieldName="interestStartDate3"
            id={"interestStartDate3"}
            name={"interestStartDate3"}
            onChangeInputField={this.onChangeInterestStartDate}
          />
          <Form.Field
            label={t("วันที่ทำสัญญาประนีประนอมยอมความ")}
            control={DateInput}
            value={this.state.paidStartDate}
            fieldName="contractStartDate"
            id={"contractStartDate3"}
            name={"contractStartDate3"}
            onChangeInputField={this.onChangePaidStartDate}
          />
          <Form.Field
            id="form-principleVal-3"
            control={Input}
            label={t("เงินต้น")}
            value={currency(this.state.principleVal)}
            onChange={(e: any, val: any) => { this.setState({ principleVal: Number(val.value.replace(/,/g, "")) }) }}
          />
          <Form.Field
            id="form-interest-rate-3"
            control={Input}
            label={t("อัตราดอกเบี้ย (%)")}
            value={this.state.interestRate}
            onChange={(e: any, val: any) => { this.setState({ interestRate: val.value }) }}
          />
          <Button
            style={{ whiteSpace: 'nowrap', width: '77px', height: '36px', marginTop: '25px', padding: '10px' }}
            onClick={this.renderResult}
            color="blue"
          >คำนวณ</Button>
        </Form.Group>
        <Form.Group widths={"equal"}>
          <Form.Field
            label={t("module.debtCollection.debtCollectionSueForm.lawyerFee")}
            control={Input}
            value={currency(this.state.lawyerFee)}
            fieldName="lawyerFee"
            id={"lawyerFee"}
            onChange={(e: any, val: any) => { this.setState({ lawyerFee: Number(val.value.replace(/,/g, "")) }) }}
          />
          <Form.Field
            id="form-select-interval"
            control={Input}
            label={t("module.debtCollection.debtCollectionSueForm.fee")}
            value={currency(this.state.fee)}
            onChange={(e: any, val: any) => { this.setState({ fee: Number(val.value.replace(/,/g, "")) }) }}
          />
          <Form.Field
            id="form-select-interval"
            control={Input}
            label={t("module.debtCollection.debtCollectionSueForm.otherAmount")}
            value={currency(this.state.otherExpense)}
            onChange={(e: any, val: any) => { this.setState({ otherExpense: Number(val.value.replace(/,/g, "")) }) }}
          />
        </Form.Group>
        {this.renderTable()}
      </Form>
    );
  }

  public renderTable() {
    return (
      <React.Fragment>
        <Grid>
          <Grid.Row>
            <Grid.Column textAlign="center">
              <hr />
              จำนวนเงินที่จ่ายในวันทำสัญญาประนีประนอมยอมความ
              <hr />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={9} textAlign="right">แบ่งเป็น</Grid.Column>
            <Grid.Column width={2}>1.เงินต้นแบ่งครึ่ง</Grid.Column>
            <Grid.Column width={1} textAlign="right">{currency(this.state.principleVal / 2, 2)}</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={9} textAlign="right"></Grid.Column>
            <Grid.Column width={2}>2.ดอกเบี้ย</Grid.Column>
            <Grid.Column width={1} textAlign="right">{currency(this.state.interestVal, 2)}</Grid.Column>
          </Grid.Row>
          {/* <Grid.Row>
            <Grid.Column width={9} textAlign="right"></Grid.Column>
            <Grid.Column width={2}>3.ค่าทนาย</Grid.Column>
            <Grid.Column width={1} textAlign="right">{currency(this.state.lawyerFee, 2)}</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={9} textAlign="right"></Grid.Column>
            <Grid.Column width={2}>4.ค่าฤชาธรรมเนียม</Grid.Column>
            <Grid.Column width={1} textAlign="right">{currency(this.state.fee, 2)}</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={9} textAlign="right"></Grid.Column>
            <Grid.Column width={2}>5.ค่าใช้จ่ายอื่นๆ</Grid.Column>
            <Grid.Column width={1} textAlign="right">{currency(this.state.otherExpense, 2)}</Grid.Column>
          </Grid.Row> */}
          <Grid.Row>
            <Grid.Column width={9} textAlign="right"></Grid.Column>
            <Grid.Column width={2} textAlign="right">รวม</Grid.Column>
            <Grid.Column width={1} textAlign="right">{currency(this.state.totalPaid, 2)}</Grid.Column>
          </Grid.Row>
        </Grid>
      </React.Fragment>
    )
  }

  private onChangeInterestStartDate = (f: any, val: any) => { this.setState({ interestStartDate: val }) }
  private onChangePaidStartDate = (f: any, val: any) => { this.setState({ paidStartDate: val }) }

  public getOptions = (val: number) => {
    let ret = [];
    for (let i = 1; i <= val; i++) {
      let d = { key: i, value: i, text: i };
      ret.push(d);
    }
    return ret;
  }

  public onCalClick() {

  }

  public renderResult = async () => {
    const { t } = this.props;
    let principle = this.state.principleVal;
    let startCalDate = new Date(this.state.interestStartDate);
    let firstPaidDate = new Date(this.state.paidStartDate);
    let dayDiff = this.dateDiff(firstPaidDate, startCalDate);
    let interestRate: number = this.state.interestRate;
    let lawyerFee: number = this.state.lawyerFee;
    let fee: number = this.state.fee;
    let otherAmount: number = this.state.otherExpense;
    let interestVal: number = this.calInterest(interestRate, dayDiff, principle);
    let totalPaid: number = principle / 2 + interestVal //+ lawyerFee + fee + otherExpense;
    this.setState({ totalPaid: totalPaid, interestVal: interestVal });
    return;
  }

  public toNextMonth(d: Date) {
    if (d.getDay() > 5) {

    } else {
      d.setMonth(d.getMonth() + 1);
    }
    let mon = new Date(d.getFullYear() + "-" + d.getMonth().toString().padStart(2, '0') + '-05');
    return mon;
  }

  public dateDiff(d1: Date, d2: Date) {
    return (d1.getTime() - d2.getTime()) / (1000 * 3600 * 24) + 1;
  }

  public calInterest(rate: number, days: number, principle: number) {
    return principle * (rate / 100) * (days / 365);
  }

  public printThaiDate(d: Date) {
    return d.toLocaleDateString("th-TH", { year: 'numeric', month: 'long', day: 'numeric' });
  }

}



export default withTranslation()(DebtCollectionSueCalculator3);